import React, { useState, useEffect } from 'react';
import { Alert, Col, Container, FormCheck, OverlayTrigger, Row, Table, Tooltip } from 'react-bootstrap';
import '../../../styles/RegDashboard.css';
import { HHIEButton } from '../../utility/HHIEButton';
import { DeactivateByWhen } from './Modals/DeactivateByWhen';
import { RemoveModal } from './Modals/RemoveModal';
import { ContentBox } from './utility/ContentBox';
import { ContentItem } from './utility/ContentItem';
import { ContentTitle } from './utility/ContentTitle';

export function RegMemberTable(props) {
    const [account, setAccount] = useState(null);
    const [members, setMembers] = useState(null);
    const [removedMembers] = useState([]);
    const [completeCheck, setCompleteCheck] = useState(false);
    const [inactiveCheck, setInactiveCheck] = useState(false);
    const [incompleteCheck, setIncompleteCheck] = useState(false);
    const [newCheck, setNewCheck] = useState(false);
    const [processingCheck, setProcessingCheck] = useState(false);
    const [disableAdd, setDisableAdd] = useState(false);

    useEffect(() => {
        setAccount(props.Account);
        setMembers(props.Members);
        setDisableAdd(props.disableAdd);
    }, [props]);

    const currentServices = (member) => {
        var services = "";
        if (member.chr) services += "CHR;";
        if (member.dsm) services += "DSM;";
        if (member.referrals) services += "Referrals;";
        if (member.notify) services += "Notify;";
        if (services.length > 0) {
            services = services.slice(0, -1);
        }
        return services;
    }

    const AddNewMember = () => {
        fetch('api/registration/GetNewMemberForAccount/' + account.id + '/' + encodeURIComponent(account.legalName))
            .then((response) => {
                response.json()
                    .then((member) => {
                        if (member.errors !== null && member.errors !== "") alert(member.errors)
                        sessionStorage.setItem("member", JSON.stringify(member.message));
                        window.location.href = "/member-form";
                    })
            })
    }
    /**
     * Creates a ticket to deactivate a user with the Salesforce Id, and makes the UI show specified member as 'Requested as Deactivated'.
     * @param {string} sfid 
     */
    const deactivateMember = async (sfid) => {
        try {
            const formData = new FormData();
            formData.append("sfid", sfid);
            const requestOptions = {
                method: 'POST',
                body: formData
            }

            const memberHasSuccessfullyBeenRequestedToBeDeactivated = await fetch('api/member/deactivate-member', requestOptions)
                .then(async (response) => {
                    try {
                        return await response.json().then(json => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors)
                            return json.message;
                        });
                    }
                    catch (error) {
                        return console.log(error);
                    }
                })
                .catch((error) => {
                    console.log(error);
                }
                );
            for (let member of members) {
                if (member.id === sfid) {
                    member.deactivationRequested = memberHasSuccessfullyBeenRequestedToBeDeactivated;
                }
            }
            let membersCopy = [...members];
            props.setMembers(membersCopy);
            setMembers(membersCopy);
        }
        catch (ex) {
            console.log(ex);
        }
    }

    const checkMemberStatus = (member) => {
        if (member.processing) {
            return "Processing"
        }
        if (member.registrationComplete) {
            return member.status
        }
        var status;

        if (member.id === null || member.id === "" || member.id === "null") {
            status = "New, ";
        }
        else {
            status = "Updated, ";
        }
        if (CheckMemberBasicsReadyToSubmit(member)) {

            if ((CheckProviderReadyToSubmit(member) ||
                CheckStaffReadyToSubmit(member) ||
                (!member.passStatus.type || member.passStatus.type === "")) && (!member.isPOC ||
                    CheckPOCReadyToSubmit(member))) {
                status += "Ready to Submit"
            }
            else {
                status += "Incomplete";
            }
        }
        else {
            status += "Incomplete";
        }
        return status;
    }

    const CheckMemberBasicsReadyToSubmit = (memberToCheck) => {
        var result;
        var today = new Date();
        var ten = new Date(today.getFullYear() - 10, 0, 0);
        var onefifty = new Date(today.getFullYear() - 150, 0, 0);
        if (ten < new Date(memberToCheck.dob) || onefifty > new Date(memberToCheck.dob)) {
            return false;
        }
        else if (memberToCheck.firstName && memberToCheck.firstName !== ""
            && memberToCheck.lastName && memberToCheck.lastName !== ""
            && (memberToCheck.hasNoMiddleName || (memberToCheck.middleName && memberToCheck.middleName !== ""))
            && memberToCheck.email && memberToCheck.email.includes("@") && memberToCheck.email.includes(".")) {
            result = true;
        }
        else { result = false }
        return result;
    }

    const CheckProviderReadyToSubmit = (member) => {
        var result;
        if ((member.passStatus.type && member.passStatus.type === "Provider" &&
            (member.npi && member.npi.length === 10
                && member.stateLicense && member.stateLicense !== "")
            && member.abbrTitle && member.abbrTitle !== ""
            && member.specialty && member.specialty !== "")) {
            result = true;
        }
        else { result = false }
        return result;
    }

    const CheckStaffReadyToSubmit = (member) => {
        var result;
        if ((member.passStatus.type && (member.passStatus.type === "Staff Member" ||
            (member.passStatus.type === "Specialty Staff" &&
            member.jobTitle && member.jobTitle !== "")))) {
            result = true;
        }
        else { result = false }
        return result;
    }

    const CheckPOCReadyToSubmit = (member) => {
        var result;
        if (member.isPOC && member.pocTypeName && member.pocTypeName !== "") result = true;
        else result = false;
        return result;
    }

    const filterMembersList = () => {
        return members.filter(member => {
            if (!completeCheck && !inactiveCheck && !incompleteCheck && !newCheck && !processingCheck) return true;
            CheckMemberRemoved(member);
            if (CheckMemberComplete(member)) return true;
            if (CheckMemberInactive(member)) return true;
            if (CheckMemberIncomplete(member)) return true;
            if (newCheck && !member.registrationComplete && (!member.id || member.id === "")) return true;
            if (processingCheck && member.processing) return true;
            return false;
        });
    }

    const CheckMemberRemoved = (memberToFilter) => {
        for (var i = 0; i < (removedMembers.length - 1); i++) {
            if (memberToFilter.mid === removedMembers[i]) return false;
        }
    }

    const CheckMemberComplete = (memberToFilter) => {
        var result;
        if (completeCheck && memberToFilter.registrationComplete && !memberToFilter.processing && memberToFilter.status === "Active") result = true;
        else result = false;
        return result;
    }

    const CheckMemberInactive = (memberToFilter) => {
        var result;
        if (inactiveCheck && memberToFilter.registrationComplete && !memberToFilter.processing && memberToFilter.status === "Inactive") result = true;
        else result = false;
        return result;
    }

    const CheckMemberIncomplete = (memberToFilter) => {
        var result;
        if (incompleteCheck && !memberToFilter.registrationComplete && !memberToFilter.processing && (memberToFilter.id && memberToFilter.id !== "")) result = true;
        else result = false;
        return result
    }
    const handleUndoDeactivationByDate = async (member) => {
        const sfid = member.id;
        if (sfid === null || sfid === undefined || sfid === "") {
            return;
        }
        const formData = new FormData();
        formData.append("sfid", sfid);
        const requestOptions = {
            method: 'POST',
            body: formData
        }
        const dateResetToNull 
            = await fetch('api/member/cancel-scheduled-deactivation-request', requestOptions)
            .then(async (response) => {
                try {
                    return await response.json().then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        return json.message
                    });
                }
                catch (error) {
                    console.log("handleUndoDeactivationByDate json:", error);
                    return false;
                }
            })
            .catch((error) => {
                console.log("handleUndoDeactivationByDate response:", error);
                return false;
            });
        if (dateResetToNull) {
            for (let mem of members) {
                if (mem.id === sfid) {
                    mem.deactivationDate = null;
                }
            }
            let membersCopy = [...members];
            setMembers(membersCopy);
            account.Members = membersCopy;
            setAccount(account);
        }
    }
    const renderMembers = () => {
        let filteredMembers = filterMembersList();
        let copyOfMembers = [...members];
        return filteredMembers.map((member, idx) => {
            return (
                <tr key={"member" + idx}>
                    <td>{member.firstName} {member.middleName} {member.lastName}</td>
                    <td>{currentServices(member)}</td>
                    <td>{checkMemberStatus(member)}</td>
                    <td>{member.createdDate.split("T")[0]}</td>
                    {/*<td> Modified By </td>*/}
                    {/*<td> Modified Date </td>*/}
                    <td className="d-flex justify-content-end">
                        {(!member.deactivationRequested && !member.processing && member.deactivationDate === null) &&
                            <div style={{ padding: "2px" }}>
                                <HHIEButton
                                    disabled={member.processing}
                                    variant="primary" 
                                    size="sm"
                                    onClick={
                                        () => {
                                            sessionStorage.setItem("member", JSON.stringify(member));
                                            window.location.href = "/member-form"
                                        }}
                                    title="Edit"
                                />
                            </div>
                        }
                        {/* Here we check the member's deactivationDate, 
                        if  (!NULL &&  !deactivatedRequested)
                            THEN show alert 
                        */}
                        {(member.deactivationDate !== null && !member.deactivationRequested) &&
                            <Alert variant='warning'>
                                Requesting Deactivation on {member.deactivationDate.split("T")[0]}
                                <HHIEButton 
                                    variant="outline-primary" 
                                    size="sm"
                                    marginl={6}
                                    onClick={() => {handleUndoDeactivationByDate(member);}} 
                                    title="Cancel"
                                />
                            </Alert>
                        }
                        {(member.deactivationRequested === true) &&
                            <Alert variant='danger'>Pending Deactivation</Alert>
                        }
                        {(!member.deactivationRequested && member.processing) &&
                            <Alert variant='info'>Pending Changes</Alert>
                        }

                        {
                        /* 
                        Here is deactivation button, should make it a modal?
                        ----------------------------------------------------
                        */
                        }
                        {(!member.deactivationRequested && !member.processing && member.deactivationDate === null) &&
                        <>
                            {(member.id && member.id !== "") &&
                            <div 
                                style={{ padding: "2px" }}
                            >
                                <DeactivateByWhen 
                                    member={member}
                                    members={copyOfMembers}
                                    setMembers={setMembers}
                                />
                            </div>}
                            <div 
                                style={{ padding: "2px" }}
                            >
                                {(member.id && member.id !== "") ?
                                    <HHIEButton 
                                        variant="danger"
                                        size="sm"
                                        disabled={member.deactivationRequested || member.processing} 
                                        onClick={() => { deactivateMember(member.id); }}
                                        title="Deactivate Now"
                                    />
                                    : <RemoveModal
                                        removeMember={(mid) => {
                                            let membersList = members.filter(thisMember => {
                                                if (thisMember.mid === mid) return false;
                                                return true;
                                            })
                                            props.setMembers(membersList);
                                            setMembers(membersList);
                                        }}
                                        member={member}
                                    />
                                }
                            </div>
                        </>
                        }
                    </td>
                </tr>
            )
        });
    };

    return (
        <ContentBox>
            <Row>
                <ContentTitle
                    position="left"
                    title="Members"
                />
                {/* REFACTOR THE CONTENT  */}
                <ContentItem
                    position="most-right"
                    content={disableAdd ?
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip id="dept-name-tip">All required Organization fields need to be filled and submitted before adding new members.</Tooltip>}
                        >
                            <Col className="d-flex justify-content-end">
                                <HHIEButton
                                    id="add-new-member"
                                    variant="primary"
                                    size="sm"
                                    disabled={disableAdd}
                                    onClick={() => { AddNewMember() }}
                                    title="Add New Member"
                                />
                            </Col>
                        </OverlayTrigger>
                        :
                        <Col className="d-flex justify-content-end">
                            <HHIEButton
                                id="add-new-member"
                                variant="primary"
                                size="sm"
                                disabled={disableAdd}
                                onClick={() => { AddNewMember() }}
                                title="Add New Member"
                            />
                        </Col>
                    }/>
            </Row>
            
            <Row>
            <ContentItem
                position="left"
                label="Filters"
            />
            </Row>
            <hr/>
            <Row style={{
                margin: 'auto'
                ,textAlign: 'center'
            }}>
                <Col>
                    <FormCheck
                        label={'Active'}
                        id={"complete-check"}
                        defaultChecked={completeCheck}
                        onChange={(e) => { setCompleteCheck(e.target.checked); }}
                    />
                </Col>
                <Col>
                    <FormCheck
                        label={'Inactive'}
                        id={"inactive-check"}
                        defaultChecked={inactiveCheck}
                        onChange={(e) => { setInactiveCheck(e.target.checked); }}
                    />
                </Col>
                <Col>
                    <FormCheck
                        label={'Incomplete'}
                        id={"incomplete-check"}
                        defaultChecked={incompleteCheck}
                        onChange={(e) => { setIncompleteCheck(e.target.checked); }}
                    />
                </Col>
                <Col>
                    <FormCheck
                        label={'New'}
                        id={"new-check"}
                        defaultChecked={newCheck}
                        onChange={(e) => { setNewCheck(e.target.checked); }}
                    />
                </Col>
                <Col>
                    <FormCheck
                        label={'Processing'}
                        id={"processing-check"}
                        defaultChecked={processingCheck}
                        onChange={(e) => { setProcessingCheck(e.target.checked); }}
                    />
                </Col>
                
            </Row>
            <hr/>
            <Table
                id="members-table"
                className="members-table"
                striped
                bordered
                hover
                responsive="sm"
                variant="light">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Services</th>
                        <th>Status</th>
                        <th>Created Date</th>
                        {/*<th>Modified By</th>*/}
                        {/*<th>Modified Date</th>*/}
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {members ? renderMembers() : <></>}
                </tbody>
            </Table>
        </ContentBox>
    );
}
